import { authenticatedFetch } from './base'

export const fetchPricePromotion = () => {
	return authenticatedFetch(`/api/price/promotion`, { method: 'get' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}